import React, { useState } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { AuthPermissions } from 'skipify-types';

import { SearchTextField, FiltersButton } from '../../Paylinks/components';
import { Button } from '../../../components/core';
import { CreateTransactionModal } from '../components/CreateTransaction/CreateTransactionModal';
import { useMerchant } from '../../../contexts/MerchantContext';
import appTheme from '../../../styles/themes/theme';

interface Props {
  onSearch: (query: string) => void;
  filtersCount: number;
  onFiltersClick: () => void;
}

export const TableHeader = ({ onSearch, filtersCount, onFiltersClick }: Props) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { canAccess } = useMerchant();
  const isMobile = useMediaQuery(appTheme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <>
        <CreateTransactionModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Typography component="h2" fontWeight="semibold" variant="large">
            Transactions
          </Typography>
        </Box>
        <Box>
          <SearchTextField
            label="Search for customer name, email, phone, or other details"
            onSearch={onSearch}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FiltersButton filtersCount={filtersCount} onClick={onFiltersClick} />
          <Button
            text="Create transaction"
            onClick={() => setIsCreateModalOpen(true)}
            disabled={
              !canAccess(AuthPermissions.CHARGE_MIT) && !canAccess(AuthPermissions.CHARGE_OWN_MIT)
            }
            sx={{ px: 4, py: 1.5, width: '100%' }}
          />
        </Box>
      </>
    );
  }
  return (
    <>
      <CreateTransactionModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography component="h2" fontWeight="semibold" variant="xl">
          Transactions
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
        <SearchTextField
          label="Search for customer name, email, phone, or other details"
          onSearch={onSearch}
        />
        <FiltersButton filtersCount={filtersCount} onClick={onFiltersClick} />
        <Button
          text="Create transaction"
          onClick={() => setIsCreateModalOpen(true)}
          disabled={
            !canAccess(AuthPermissions.CHARGE_MIT) && !canAccess(AuthPermissions.CHARGE_OWN_MIT)
          }
          sx={{ px: 5, py: 1.5, whiteSpace: 'nowrap' }}
        />
      </Box>
    </>
  );
};
